import * as tslib_1 from "tslib";
import { Review } from '../../shared/models/review.model';
/**
 * Airport review/rating model
 */
var AirportReview = /** @class */ (function (_super) {
    tslib_1.__extends(AirportReview, _super);
    function AirportReview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Parses review
     * @param data {any} Review data as returned by API
     * @return {AirportReview} Parsed review
     */
    AirportReview.parse = function (data) {
        var review = Review.parse(data);
        review.airportId = data.airportId;
        return review;
    };
    return AirportReview;
}(Review));
export { AirportReview };
